<template lang="pug">
  picture
    source(
      type=`image/webp`
      :media="media()"
      :srcset="srcset(true, true)"
    )
    source(
      type=`image/webp`
      :srcset="srcset(false, true)"
    )
    source(
      :media="media()"
      :srcset="srcset(true, false)"
    )
    img.picture__img(
      :class="imgClass"
      :src="`${mobileName}@1x.${mobileExtension}`"
      :srcset="srcset(false, false)"
      :alt="`${alt}`"
    )
</template>

<script>
export default {
  props: {
    imgClass: String,
    minScreenWidth: {
      type: String,
      default: `1024px`
    },
    desktopName: String,
    mobileName: String,
    desktopExtension: {
      type: String,
      default: `png`
    },
    mobileExtension: {
      type: String,
      default: `png`
    },
    alt: String
  },
  methods: {
    media () {
      return `(min-width: ${this.minScreenWidth})`
    },
    srcset (isDesktop, isWebp) {
      const name = isDesktop ? this.desktopName : this.mobileName
      const ext = isWebp ? `webp` : `${this.desktopExtension}`
      const picture1x = `${process.env.BASE_URL}img/${name}@1x.${ext} 1x`
      const picture2x = `${process.env.BASE_URL}img/${name}@2x.${ext} 2x`
      const srcset = `${picture1x}, ${picture2x}`
      return srcset
    }
  }
}
</script>

<style lang="scss">
  picture {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .picture__img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    object-fit: cover;
    transition: $trs;

    &--contain {
      object-fit: contain;
    }
  }
</style>
